import { useRedux } from "hooks"
import { useEffect, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";
import { Const } from "const";



interface SelectDropdownWeekDayProps {
  onSelectDays: (day: number[] | null) => void;
  selectedDays?: number[] | null;
  isDisabled: boolean;
}

const SelectDropdownWeekDay = ({ selectedDays, onSelectDays, isDisabled }: SelectDropdownWeekDayProps) => {
  const dayNo = Const.WEEK_DAY_NO;
  const dayName = Const.WEEK_DAY_NAME;

  const weeks = Array.from({ length: 7 }, (_, i) => {
    const label = dayName[i];
    const value = dayNo[i];

    return { label, value };
  });

  // console.log('date:', dates);

  return (
    <SelectDropdown
      isDisabled={isDisabled}
      isMulti={true}
      list={weeks}
      onValueChanged={(e) => { onSelectDays(e.map((x: any) => x.value)) }}
      selectedValue={weeks.filter(x1 => selectedDays?.includes(x1.value))}
    />
  )
}

export default SelectDropdownWeekDay

